import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { IFormattedTranscriptWord } from '@models/grade-unit/transcript';

@Component({
  selector: 'app-transcript',
  templateUrl: './transcript.component.html',
  styleUrls: ['./transcript.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TranscriptComponent {
  @Input() public currentTime: number = 0;
  @Input() public transcriptWordList: IFormattedTranscriptWord[] = [];
}
